module.exports = __webpack_public_path__ + "static/img/logo_color.f270607.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/logo_color.svg
// module id = +mX4
// module chunks = 0